// Extract a lowercased file extension from a URL.
//
// Strips any query string or hash fragment first, so signed URLs (e.g. Azure
// SAS blobs like `.../file.docx?sr=b&sig=...&sv=2018-11-09`) resolve to the real
// extension instead of capturing the query as part of it. Returns undefined when
// no url is provided.
export function fileExtensionFromUrl(url) {
  return url?.split(/[?#]/)[0].split(".").pop().toLowerCase();
}
